import { Colors, GridBreakpointsMediaUp } from '@dbi-tools/ui-kit';
import styled from 'styled-components';

export const DatepickerWrapStyled = styled('div')`
  margin-bottom: 30px;

  ${GridBreakpointsMediaUp.md} {
    max-width: 230px;
  }

  input {
    min-width: 160px;
    font-weight: bold;
    font-size: 16px !important;
    color: ${Colors.wine} !important;
    background-color: transparent !important;

    &::placeholder {
      color: ${Colors.wine} !important;
    }
  }
`;

export const ThumbnailImg = styled('div')`
  position: relative;

  img {
    max-width: 100%;
    position: relative;
    display: block;
  }
`;
